import EntryProceduresSection from './EntryProceduresSection';

export default EntryProceduresSection;
